;(function($){
  var $formSelectOuter = $('.js-form-select-outer');
  if ($formSelectOuter.length) {
    var $select = $formSelectOuter.find('select:not([multiple])');

    $select.wrap('<div class="form-select-field"></div>')
    $select.parent('.form-select-field').append('<i class="icon-down-open-big"></i>');
  }
})(jQuery);
